import dsBridge from 'dsbridge';
import { nativeMethods } from './nativeMethods';
import { isAppEnv } from '@/utils/device';

export const Bridge = {
  /**
   * call The front-end actively triggers the agreed method with the native, and then passes the value to the native, hoping that the native can do some operations;
   * @param {*} name  Method name
   * @param {*} data  The web passes native data
   * @param {*} callback A callback function that returns natively
   */
  callFn(name, data, callback = () => {}) {
    // Determine whether it is in the browser environment
    if (!isAppEnv()) {
      nativeMethods.call(name, data, res => {
        callback(res);
      });
      return;
    }
    dsBridge.call(
      'asynJSCallNative',
      JSON.stringify({
        methodName: name,
        params: data
      }),
      resData => {
        /**
         * status: 0 Request successful
         * status: -1 There is no such method
         * status: -2 Parameter error
         * **/
        const res = JSON.parse(resData);
        if (res?.status !== 0) {
          // Output error cause
          // eslint-disable-next-line no-console
          console.error(res, 'bridge callFn error');
        } else {
          callback(res.data);
        }
      }
    );
  },

  callFnVal(name, data) {
    return new Promise(resolve => {
      // Determine whether it is in the browser environment
      if (!isAppEnv()) {
        nativeMethods.call(name, data, res => {
          resolve(res);
        });
        return;
      }
      dsBridge.call(
        'asynJSCallNative',
        JSON.stringify({
          methodName: name,
          params: data
        }),
        resData => {
          /**
           * status: 0 Request successful
           * status: -1 There is no such method
           * status: -2 Parameter error
           * **/
          const res = JSON.parse(resData);
          if (res?.status !== 0) {
            // Output error cause
            // eslint-disable-next-line no-console
            console.error(res, 'bridge callFnVal error');
          } else {
            resolve(res.data);
          }
        }
      );
    });
  },

  /**
   * register: Register an event defined natively by the app. When the event is triggered natively, // front-end will listen here and perform some business operations;
   * @param {*} tag Method name
   * @param {*} callback Data passed natively
   */
  // Method name, natively passed data
  registerFn(tag, callback = () => {}) {
    dsBridge.register(tag, callback);
  },

  // Check whether the webview page has native methods or not
  hasNativeMethodFn(name, type = 'all') {
    return dsBridge.hasNativeMethod(name, type);
  }
};
